<script>
	import { io } from 'socket.io-client';
	import { spring } from 'svelte/motion';
	import { userSignIn } from '$lib/apis/auths';

	let loadingProgress = spring(0, {
		stiffness: 0.05
	});

	import { onMount, tick, setContext, getContext } from 'svelte';
	import {
		config,
		user,
		credits,
		theme,
		WEBUI_NAME,
		mobile,
		socket,
		activeUserCount,
		USAGE_POOL
	} from '$lib/stores';
	import { goto, beforeNavigate } from '$app/navigation';
	import { Toaster, toast } from 'svelte-sonner';

	import { getBackendConfig } from '$lib/apis';
	import { getSessionUser, updateSessionUser } from '$lib/apis/auths';

	import '../tailwind.css';
	import '../app.css';

	import 'tippy.js/dist/tippy.css';

	import { WEBUI_BASE_URL, WEBUI_HOSTNAME } from '$lib/constants';
	import i18n, { initI18n, getLanguages } from '$lib/i18n';
	export const prerender = true;

	setContext('i18n', i18n);

	let loaded = false;
	const BREAKPOINT = 768;
	const i18nl = getContext('i18n');

	let active = true;          // Flag to track if the tab is active
	let intervalId;             // Variable to store the interval ID
	const intervalTime = 20000;  // Interval time in milliseconds (1 second)

	// const updateSession = async () => {
		// console.log('User is active...');
		//await updateSessionUser(localStorage.token);
		// Insert the code you wish to execute repeatedly here
	// };

	const updateSession = async () => {
	try {
		await updateSessionUser(localStorage.token);
	} catch (error) {
		if (error?.status === 401) {
			const confirmed = confirm(
				'Your session has expired. Would you like to login again?'
			);

			if (confirmed) {
				window.open('/auth', '_blank', 'noopener,noreferrer');
			}

			return;
		}

		console.error('Update session failed:', error);
	}
};

	const startInterval = () => {
		if (!intervalId) { // Only start if it's not already running
			intervalId = setInterval(updateSession, intervalTime);
			// console.log('Interval started');
		}
	};

	const stopInterval = () => {
		if (intervalId) {
			clearInterval(intervalId);
			intervalId = null;
			// console.log('Interval stopped');
		}
	};

	const setSessionUser = async (sessionUser) => {
		if (sessionUser) {
			// console.log(sessionUser);
			toast.success($i18nl.t(`You're now logged in.`));
			localStorage.token = sessionUser.token;

			// $socket.emit('user-join', { auth: { token: sessionUser.token } });
			await user.set(sessionUser);
			console.log("Redirecting to the desired service from layout ...");
			// if(localStorage.REALM_REDIRECT_URL){
			// 	window.location.href = localStorage.REALM_REDIRECT_URL;
			// } else {
				window.location.href = '/welcome';
			// }
		}
	};

	const cogSignInHandler = async (code) => {
		const sessionUser = await userSignIn("cognito", code).catch((error) => {
			// toast.error(error);
			return null;
		});

		await setSessionUser(sessionUser);
	};

	window.addEventListener('vite:preloadError', (event) => {
		window.reload() // for example, refresh the page
	})

	onMount(async() => {
		theme.set(localStorage.theme);

		mobile.set(window.innerWidth < BREAKPOINT);
		const onResize = () => {
			if (window.innerWidth < BREAKPOINT) {
				mobile.set(true);
			} else {
				mobile.set(false);
			}
		};
		// console.log("Layout Routed from Cognito...", window.location.search, window.location.search.split("code="));
		if (window.location.search.split("?code=").length === 2) {
			// console.log("Code from Cognito...", window.location.search.split("?code=")[1]);
			await cogSignInHandler(window.location.search.split("?code=")[1]);
		}

		window.addEventListener('resize', onResize);

		let backendConfig = null;
		try {
			backendConfig = await getBackendConfig();
			// console.log('Backend config:', backendConfig);
		} catch (error) {
			console.error('Error loading backend config:', error);
		}
		// Initialize i18n even if we didn't get a backend config,
		// so `/error` can show something that's not `undefined`.

		const languages = await getLanguages();

		const browserLanguage = navigator.languages
			? navigator.languages[0]
			: navigator.language || navigator.userLanguage;

		initI18n(languages.includes(browserLanguage) ? browserLanguage : backendConfig?.default_locale);

		if (backendConfig) {
			// Save Backend Status to Store
			await config.set(backendConfig);
			await WEBUI_NAME.set(backendConfig.name);

			if ($config) {
				const _socket = io(`${WEBUI_BASE_URL}`, {
					path: '/ws/socket.io',
					auth: { token: localStorage.token }
				});

				_socket.on('connect', () => {
					console.log('connected');
				});

				await socket.set(_socket);

				_socket.on('user-count', (data) => {
					// console.log('user-count', data);
					activeUserCount.set(data.count);
				});

				_socket.on('usage', (data) => {
					USAGE_POOL.set(data['models']);
				});

				if (localStorage.token) {
					// Get Session User Info
					const sessionUser = await getSessionUser(localStorage.token).catch((error) => {
						// toast.error(error);
						return null;
					});

					if (sessionUser) {
						// Save Session User to Store
						await user.set(sessionUser);
						// Event listener for visibility change
						document.addEventListener('visibilitychange', () => {
							// if (document.visibilityState === 'visible') {
								active = true;  // Tab is active
								startInterval(); // Start the interval
							// } else {
							// 	active = false; // Tab is not active
							// 	stopInterval(); // Stop the interval
							// }
						});

						// Initial call to start the interval when the page is first loaded
						// if (document.visibilityState === 'visible') {
							startInterval(); // Start interval if the tab is already active
						// }
					} else {
						// Redirect Invalid Session User to /auth Page
						localStorage.removeItem('token');
						stopInterval(); // Stop the interval
						await goto('/auth');
					}
				} else {
					await goto('/auth');
				}
			}
		} else {
			// Redirect to /error when Backend Not Detected
			await goto(`/error`);
		}

		await tick();

		if (
			document.documentElement.classList.contains('her') &&
			document.getElementById('progress-bar')
		) {
			loadingProgress.subscribe((value) => {
				const progressBar = document.getElementById('progress-bar');

				if (progressBar) {
					progressBar.style.width = `${value}%`;
				}
			});

			await loadingProgress.set(100);

			document.getElementById('splash-screen')?.remove();

			const audio = new Audio(`/audio/greeting.mp3`);
			const playAudio = () => {
				audio.play();
				document.removeEventListener('click', playAudio);
			};

			document.addEventListener('click', playAudio);

			loaded = true;
		} else {
			document.getElementById('splash-screen')?.remove();
			loaded = true;
		}

		return () => {
			window.removeEventListener('resize', onResize);
		};
	});
</script>

<svelte:head>
	<title>{$WEBUI_NAME}</title>
	<link rel="icon" href="{WEBUI_BASE_URL}/static/logo.png" />

	<!-- rosepine themes have been disabled as it's not up to date with our latest version. -->
	<!-- feel free to make a PR to fix if anyone wants to see it return -->
	<!-- <link rel="stylesheet" type="text/css" href="/themes/rosepine.css" />
	<link rel="stylesheet" type="text/css" href="/themes/rosepine-dawn.css" /> -->
</svelte:head>

{#if loaded}
	<slot />
{/if}

<Toaster richColors position="top-right" />
